// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainbody-container {
  width: 100%;
}

.mainbody-container-hidden {
    visibility: hidden;
}

.mainbody-container-shift {
  background-color: var(--app-color-1);
  margin-left: 150px;
}

@media screen and (max-width: 1300px) {
  .mainbody-container-shift {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Mainbody/Mainbody.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".mainbody-container {\r\n  width: 100%;\r\n}\r\n\r\n.mainbody-container-hidden {\r\n    visibility: hidden;\r\n}\r\n\r\n.mainbody-container-shift {\r\n  background-color: var(--app-color-1);\r\n  margin-left: 150px;\r\n}\r\n\r\n@media screen and (max-width: 1300px) {\r\n  .mainbody-container-shift {\r\n    margin-left: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
